import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const ContactDetails = z.object({
  id: z.string(),
  personalEmail: z.string().optional(),
  telephoneNumber: z.string(),
  workEmail: z.string()
});

export type ContactDetails = z.infer<typeof ContactDetails>;

export default c.router({
  getContact: {
    method: 'GET',
    path: '/contactDetails/:id',
    responses: {
      200: ContactDetails,
      ...failedResponses
    }
  },
  postContact: {
    method: 'POST',
    path: '/contactDetails',
    responses: {
      200: ContactDetails,
      ...failedResponses
    },
    body: ContactDetails.omit({ id: true })
  },
  deleteContact: {
    method: 'DELETE',
    path: '/ContactDetails/:id',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.undefined()
  },
  updateContact: {
    method: 'PUT',
    path: '/ContactDetails/:id',
    responses: {
      200: ContactDetails,
      ...failedResponses
    },
    body: ContactDetails.omit({ id: true })
  }
});
